module.exports = __webpack_public_path__ + "img/wntj.70ba6601.png";